//C:\Users\Anish\xpr_survey\XPRSuvey-App\src\App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./Components/Auth/Pages/Login";
import AuthWrapper from "./Components/Auth/AuthWrapper";
import SurveyLayout from "./Components/Survey/SurveyLayout/SurveyLayout";
import SurveyResponderLayout from "./Components/Survey/SurveyLayout/SurveyResponderLayout";
import SurveyList from "./Components/Survey/Pages/AssessmentManagement/SurveyList";
import AddQuestions from "./Components/Survey/Pages/AssessmentManagement/AddQuestions";
import BuildAnalytics from "./Components/Analytics/Pages/BuildAnalytics";
import SurveyResponder from "./Components/Survey/Pages/SurveyResponder";
import { UserProvider } from "./Utility/userContext";
import ToastContainer from "./Utility/Alert/ToastContainer";
import PageNotFound from "./Components/PageNotFound";
import Reports from "./Components/Survey/Pages/Reports";
import Dashboard from "./Components/Survey/Pages/Dashboard";
import MasterData from "./Components/Survey/Pages/MasterData";
import AddChannel from "./Components/Survey/Pages/AddChannel";
import EditChannel from "./Components/Survey/Pages/EditChannel";
import HRLogin from "./Components/Auth/Pages/HRLogin";
import User from "./Components/Survey/Pages/UserManagement/UserList/User";
import AddUser from "./Components/Survey/Pages/UserManagement/AddUser/AddUser";
import AddCompany from "./Components/Survey/Pages/Company/AddCompany"
import ManageCompany from "./Components/Survey/Pages/Company/Dashboard";
import AssignAssessment from "./Components/Survey/Pages/UserManagement/AssignAssessment/AssignAssessment";
import AllocateAssessment from "./Components/Survey/Pages/UserManagement/AssignAssessment/AllocateSurvey"
import ShareAssessment from "./Components/Survey/Pages/UserManagement/AssignAssessment/Share"
import CompanyLayout from "./Components/HR/HRLayout/CompanyLayout";
import CompanyDashboard from "./Components/HR/Pages/DashBoard";
import CompanyProtectedRoute from "./Components/Auth/CompanyProtectedRoute";
import AssessmentList from "./Components/HR/Pages/AssessmentList";
import HRAssessmentPreview from "./Components/HR/Pages/AssessmentPreview/HRAssessmentPreview";
import HRAssessmentAnalytics from "./Components/HR/Pages/AssessmentPreview/HRAssessmentAnalytics";
import HRReports from "./Components/HR/Pages/Reports";
import AllocateSurveyToCompany from "./Components/Survey/Pages/UserManagement/AssignAssessment/AllocateSurveyToCompany";
import AllocateSurvey from "./Components/HR/Pages/AssignAssessment/AllocateSurvey";
import CompanyAssessment from "./Components/Survey/Pages/UserManagement/AssignAssessment/CompanyAssessment";


const App = () => {
  return (
    <UserProvider>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/CompanyLogin" element={<HRLogin />} />
        <Route path="/dashboard" element={<AuthWrapper><SurveyLayout /></AuthWrapper>}>
          <Route index element={<Dashboard />} />
          <Route path="Assessment-List" element={<SurveyList />} />
          <Route path="Assessment-List/Add-Questions" element={<AddQuestions />} />
          <Route path="Assessment-List/Add-Questions/assign-users/:surveyUID" element={<AllocateAssessment />} />
          <Route path="Assessment-List/Add-Questions/assign-To-Company/:surveyUID" element={<AllocateSurveyToCompany />} />
          <Route path="Assessment-List/Add-Questions/build-analytics/:surveyUID" element={<BuildAnalytics />} />
          <Route path="Assessment-List/Add-Questions/share/:surveyUID" element={<ShareAssessment />} />
          <Route path="reports" element={<Reports />} />
          <Route path="MasterData" element={<MasterData />}>
            <Route path="add-channel" element={<AddChannel />} />
            <Route path="edit-channel/:channelId" element={<EditChannel />} />
          </Route>
          <Route path="users" element={<User />}>
            <Route path="add-user" element={<AddUser />} />
          </Route>
          <Route path="users/:userId/assign-assessment" element={<AssignAssessment />} />
          <Route path="companies" element={<ManageCompany />}>
            <Route path="add-company" element={<AddCompany />} />
          </Route>
          <Route path="companies/:companyUID/assign-assessment" element={<CompanyAssessment />} />
          
        </Route>
        <Route path="/Company/dashboard" element={<CompanyProtectedRoute><CompanyLayout /></CompanyProtectedRoute>}>
          <Route index element={<CompanyDashboard />} />
          <Route path="my-assessments" element={<AssessmentList />} />
          <Route path="my-assessments/preview/:assessmentUID" element={<HRAssessmentPreview />} />
          <Route path="my-assessments/analytics/:assessmentUID" element={<HRAssessmentAnalytics />} />
          <Route path="my-assessments/assign-users/:assessmentUID" element={<AllocateSurvey />} />
          <Route path="reports" element={<HRReports />} />
        </Route>
        <Route element={<SurveyResponderLayout />}>
          <Route path="/survey-responder/:responderUID" element={<SurveyResponder />} />
        </Route>

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </UserProvider>
  );
};

export default App;
